export const normalizeUrlPath = (path) => {
  if (!path) return '/';

  const [pathname] = path.split(/[?#]/);

  if (pathname === '/') return '/';

  return pathname.replace(/\/+$/, '');
}
